<template>
  <div class="noborderdia">
    <a-modal
      :footer="null"
      :visible="visible"
      width="70%"
      centered
      :keyboard="false"
      :maskClosable="true"
      @cancel="handleCancel"
      destroyOnClose
      :getContainer="getContainer"
    >
      <div style="padding: 40px; box-sizing: border-box">
        <div class="fa">
          01、{{ t.type == 1 ? "单选题" : type == 2 ? "判断题" : "多选题" }}
        </div>
        <div class="question">
          {{ t.question }}
        </div>
        <div class="options">
          <div class="optionCol" v-if="t.q1">
            <div
              class="option"
              :class="{ optionActive: t.answer.indexOf('A') > -1 }"
            >
              <div class="op">A</div>
              <div class="txt">{{ t.q1 }}</div>
            </div>
          </div>
          <div class="optionCol" v-if="t.q2">
            <div
              class="option"
              :class="{ optionActive: t.answer.indexOf('B') > -1 }"
            >
              <div class="op">B</div>
              <div class="txt">{{ t.q2 }}</div>
            </div>
          </div>
          <div class="optionCol" v-if="t.q3">
            <div
              class="option"
              :class="{ optionActive: t.answer.indexOf('C') > -1 }"
            >
              <div class="op">C</div>
              <div class="txt">{{ t.q3 }}</div>
            </div>
          </div>
          <div class="optionCol" v-if="t.q4">
            <div
              class="option"
              :class="{ optionActive: t.answer.indexOf('D') > -1 }"
            >
              <div class="op">D</div>
              <div class="txt">{{ t.q4 }}</div>
            </div>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>
  
  <script>
export default {
  data() {
    return {
      t: {},
      visible: false,
    };
  },
  methods: {
    init(e) {
      this.t = e;
      this.visible = true;
    },
    handleCancel() {
      this.visible = false;
    },
    getContainer(){
      return document.getElementById("bodyContnet")
    }
  },
};
</script>
  
<style scoepd lang="scss">
.fa {
  font-size: 22px;
  font-weight: bold;
  line-height: 30px;
  color: #0073ff;
  margin-bottom: 20px;
}
.question {
  min-height: 200px;
  box-sizing: border-box;
  font-size: 22px;
  font-weight: 400;
  line-height: 30px;
  color: #011733;
  border-bottom: 1px solid #edf1f4;
}
.options {
  padding: 20px 0px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  // border: 1px solid red;
  .optionCol {
    padding: 20px 15px;
    box-sizing: border-box;
    width: 50%;
    height: auto;
    .option {
      padding: 34px 30px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      background: #fafbff;
      border: 1px solid #f5f6fa;
      border-radius: 4px;
      height: 100%;
      .op {
        font-size: 18px;
        color: #3c4048;
        width: 10%;
        text-align: left;
        // border: 1px solid red;
      }
      .txt {
        width: 90%;
        font-size: 22px;
        font-weight: 400;
        line-height: 30px;
        color: #011733;
        // border: 1px solid red;
        text-align: center;
      }
    }
    .optionActive {
      background: #0073ff;
      border: 1px solid #0073ff;

      .op {
        color: #fff;
      }
      .txt{
        color: #FFF;
      }
    }
  }
}
</style>